import 'angular:locale/data:en-US';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "en-US";
